"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/heading.ts
var _heading = require('@ariakit/react-core/heading/heading');
var _headinglevel = require('@ariakit/react-core/heading/heading-level');




exports.Heading = _heading.Heading; exports.HeadingLevel = _headinglevel.HeadingLevel;
